import { defineMessages } from "react-intl";

export const openingHoursMessages = defineMessages({
  sectionName: {
    id: "Cy8TYt",
    defaultMessage: "Opening hours",
    description: "section name",
  },
  menuDescription: {
    id: "fPeyYu",
    defaultMessage: "Set when the shop is open, holidays and special dates",
    description: "configuration menu item description",
  },
  intro: {
    id: "o76Ltw",
    defaultMessage:
      "These hours are shown on the website and can limit when staff may sign in (see permission groups). Times are in Lisbon time.",
    description: "page description",
  },
  openNow: {
    id: "z6KwSK",
    defaultMessage: "Open now",
    description: "status",
  },
  closedNow: {
    id: "+/Oiry",
    defaultMessage: "Closed now",
    description: "status",
  },
  weeklyTitle: {
    id: "aywus6",
    defaultMessage: "Regular week",
    description: "card title",
  },
  holidayRow: {
    id: "afFnjF",
    defaultMessage: "Public holidays",
    description: "row label",
  },
  holidayHelp: {
    id: "jfvkBL",
    defaultMessage:
      "Applies to national holidays (Ano Novo, Sexta-feira Santa, Páscoa, 25 de Abril, 1 de Maio, Corpo de Deus, 10 de Junho, 15 de Agosto, 5 de Outubro, 1 de Novembro, 1 e 8 de Dezembro, Natal). Municipal holidays: add them as special dates.",
    description: "help text under the holiday row",
  },
  closed: {
    id: "a10p86",
    defaultMessage: "Closed",
    description: "no opening periods that day",
  },
  addPeriod: {
    id: "R45QXJ",
    defaultMessage: "Add period",
    description: "button",
  },
  remove: {
    id: "bu/fC1",
    defaultMessage: "Remove",
    description: "button",
  },
  from: {
    id: "l4xbDf",
    defaultMessage: "From",
    description: "opening time input label",
  },
  to: {
    id: "0Ga3Fv",
    defaultMessage: "To",
    description: "closing time input label",
  },
  save: {
    id: "opPZR9",
    defaultMessage: "Save hours",
    description: "button",
  },
  saved: {
    id: "uFcsOU",
    defaultMessage: "Opening hours saved",
    description: "notification",
  },
  saveError: {
    id: "fkyBxG",
    defaultMessage: "Could not save: check that each period ends after it starts and none overlap",
    description: "notification",
  },
  specialTitle: {
    id: "nq6j+d",
    defaultMessage: "Special dates",
    description: "card title",
  },
  specialHelp: {
    id: "sepL5T",
    defaultMessage:
      "Pick a date on the calendar to give it its own hours. It overrides the regular week and the holiday hours — for example, the 5th of October open 09:00–15:00, or a bridge day closed. Leave no periods for closed.",
    description: "help text",
  },
  pickDate: {
    id: "6oOMnv",
    defaultMessage: "Date",
    description: "calendar input label",
  },
  specialLabel: {
    id: "QclziH",
    defaultMessage: "Note (optional)",
    description: "input label, e.g. 'Bridge day'",
  },
  normallyThatDay: {
    id: "4Qr971",
    defaultMessage: "Without a special date: {hours}",
    description: "hint about what applies on the picked date today",
  },
  saveSpecial: {
    id: "YY9W15",
    defaultMessage: "Save special date",
    description: "button",
  },
  specialSaved: {
    id: "wT35Kp",
    defaultMessage: "Special date saved",
    description: "notification",
  },
  specialDeleted: {
    id: "Yp9UJn",
    defaultMessage: "Special date removed",
    description: "notification",
  },
  noSpecial: {
    id: "O5xO8q",
    defaultMessage: "No special dates yet",
    description: "empty state",
  },
  edit: {
    id: "Ja7gHc",
    defaultMessage: "Edit",
    description: "button",
  },
  upcomingTitle: {
    id: "8Mikjt",
    defaultMessage: "Next 14 days",
    description: "card title: what visitors will see",
  },
  sourceSpecial: {
    id: "ij5Ev0",
    defaultMessage: "Special date",
    description: "why the day has these hours",
  },
  sourceHoliday: {
    id: "6kV56g",
    defaultMessage: "Holiday",
    description: "why the day has these hours",
  },
  sourceWeekday: {
    id: "nwWKdo",
    defaultMessage: "Regular",
    description: "why the day has these hours",
  },
});
